import React, { useContext, useState, useEffect, useRef } from 'react';

import { Context } from '@store/store';

import { useQuery, useMutation } from '@apollo/client';
import { 
  GET_ELIB_DOC_DATA, 
  GET_ELIB_DOC_CREATE, 
  GET_ELIB_DOC_UPDATE, 
  GET_ELIB_DOC_DELETE 
} from '@graphql/editor';

import * as quillToWord from 'quill-to-word';
import { saveAs } from 'file-saver';

import OpenDocIcon from '@icons/editor/open-doc-icon';
import AddDocIcon from '@icons/editor/add-doc-icon';
import TrashIcon from '@icons/editor/trash-icon';
import DropdownIcon from '@icons/editor/dropdown-icon';
import DownloadIcon from '@icons/editor/download-icon';

import { 
  DropdownContainer, 
  DropdownButton, 
  Dropdown, 
  DropdownItem, 
  Wrapper, 
  UpdateModal, 
  UpdateModalBody, 
  UpdateModalFooter, 
  UpdateModalInput, 
  UpdateModalBtnWhite, 
  UpdateModalBtn, 
  StyledHeader, 
  StyledBody, 
  StyledBodyLoad, 
  AddCard, 
  DocCard, 
  DocItem, 
  Text, 
  TextBlock, 
  IconBlock 
} from './editor-comment.styles';

const EditorOpenDoc = ({bookId}) => {
  const [state, dispatch] = useContext(Context);
  const { loading, error, data, refetch } = useQuery(GET_ELIB_DOC_DATA, { variables: { first: 100, page: 1 } });
  const [createDoc, { data:createData, loading:createLoading, error:createError }] = useMutation(GET_ELIB_DOC_CREATE);
  const [updateDoc, { data:updateData, loading:updateLoading, error:updateError }] = useMutation(GET_ELIB_DOC_UPDATE);
  const [deleteDoc, { data:deleteData, loading:deleteLoading, error:deleteError }] = useMutation(GET_ELIB_DOC_DELETE);

  const remove = (id) => {
    deleteDoc({
      variables: {
        id: `${id}`
      }
    }).then((res) => {
      dispatch({ type: 'SHOW_EDITOR_MODAL', payload: true, action: 'Конспект удален' });
    })
  };

  const update = (ids, title, content, delta) => {
    updateDoc({
      variables: {
        id: `${ids}`,
        title: `${title}`,
        content: `${content}`,
        delta: `${delta}`,
      }
    })
  };

  const download = async (content, title, delta) => {
    const getdelta = JSON.parse(delta);
    const quillToWordConfig = {
        exportAs: 'blob'
    };
    const docAsBlob = await quillToWord.generateWord(getdelta, quillToWordConfig);
    saveAs(docAsBlob, `${title}.docx`); 
    dispatch({ type: 'SHOW_EDITOR_MODAL', payload: true, action: 'Конспект скачан' });
  }

  const createSubmit = () => {
    const date = new Date().toLocaleString();
    createDoc({
      variables: {
        title: 'Новый конспект ' + date,
        content: '',
        delta: '',
        create_book: bookId
      }
    }).then((res) => {
      dispatch({ type: 'TOGGLE_EDITOR_NEW_DOC_MODAL', edit_doc: res?.data?.elibReaderDocCreate?.id });
    })
  };

  useEffect(() => {
    refetch()
  }, [state.isEditorOpenDocSidebarOpened, data, deleteLoading, updateLoading]);

  if (loading || createLoading || deleteLoading || updateLoading)
    return (
      <div style={{ display: state.isEditorOpenDocSidebarOpened ? 'block' : 'none' }}>
        <Wrapper>
          <StyledHeader>
            Создать/Выбрать конспект
          </StyledHeader>
          <StyledBodyLoad>
            <p>Загрузка</p>
          </StyledBodyLoad>
        </Wrapper>
      </div>
    );

  if (error || createError || deleteError || updateError)
    return (
      <div style={{ display: state.isEditorOpenDocSidebarOpened ? 'block' : 'none' }}>
        <Wrapper>
          <StyledHeader>
            Создать/Выбрать конспект
          </StyledHeader>
          <StyledBodyLoad>
            <p>Ошибка: {error.message}</p>
          </StyledBodyLoad>
        </Wrapper>
      </div>
    );
    
  return (
      <div style={{ display: state.isEditorOpenDocSidebarOpened ? 'block' : 'none' }}>
        <Wrapper>
          <StyledHeader>
            Создать/Выбрать конспект
          </StyledHeader>
          <StyledBody>
            <DocCard> 
              <DocItem       
                data-ignore-click-outside="sidebar"
                onClick={() => {
                  createSubmit();
                }}
                title="Создать конспект"
              >
                <IconBlock>
                  <AddDocIcon width="30px" height="30px"/>
                </IconBlock>
                <TextBlock>
                  <Text>Создать конспект</Text>
                </TextBlock>
              </DocItem>
            </DocCard>
            {data?.elibReaderDocData?.data?.map(item => (
              <DocCard>  
                <DocItem            
                  onClick={() => {
                    dispatch({ type: 'TOGGLE_EDITOR_NEW_DOC_MODAL', edit_doc: item.id });
                  }}
                  title="Выбрать конспект"
                >
                  <IconBlock>
                    <OpenDocIcon width="30px" height="30px"/>
                  </IconBlock>
                  <TextBlock>
                    <div>
                      <Text>{item.title}</Text>
                      <Text>{item.created_at}</Text>
                    </div>
                  </TextBlock>
                </DocItem>
                <DropdownList download={download} remove={remove} update={update} item={item}/>
              </DocCard>
            ))}
          </StyledBody>
        </Wrapper>
      </div>
    );
};

const DropdownList = (props) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [getTitle, setGetTitle] = useState(props.item.title);
  const wrapperRef = useRef();
  useOnClickOutside(wrapperRef, () => setDropdownActive(false));
  useEffect(() => {
    setGetTitle(props.item.title);
  }, [updateModal]);
  return (
    <>
      <DropdownContainer ref={wrapperRef}>
        <DropdownButton onClick={() => setDropdownActive(!dropdownActive)}>
          <DropdownIcon width="30px" height="30px"/>
        </DropdownButton>
        <Dropdown style={{ display: dropdownActive ? 'block' : 'none' }}>
          <DropdownItem title="Переименовать конспект" onClick={() => setUpdateModal(true)}>
            <OpenDocIcon width="30px" height="20px"/> Переименовать
          </DropdownItem>
          {props.item.content !== '' &&
          <DropdownItem title="Скачать конспект" onClick={() => {props.download(props.item.content, props.item.title, props.item.delta)}}>
            <DownloadIcon width="30px" height="20px"/> Скачать
          </DropdownItem>}
          <DropdownItem title="Удалить конспект" onClick={() => setRemoveModal(true)}>
            <TrashIcon width="30px" height="20px"/> Удалить
          </DropdownItem>
        </Dropdown>
      </DropdownContainer>
      {updateModal &&
        <UpdateModal>
         <UpdateModalBody>
          <h2>Переименование</h2>
          <p>Введите новое название:</p>
          <UpdateModalInput type="text" placeholder="" value={getTitle} onChange={(e) => {setGetTitle(e.target.value)}}/>
          <UpdateModalFooter>
            <UpdateModalBtnWhite onClick={() => setUpdateModal(false)}>Отмена</UpdateModalBtnWhite>
            <UpdateModalBtn onClick={() => getTitle !== props.item.title ? props.update(props.item.id, getTitle, props.item.content, props.item.delta) : null}>ОК</UpdateModalBtn>
          </UpdateModalFooter>
          </UpdateModalBody>
        </UpdateModal>
      }
      {removeModal &&
        <UpdateModal>
          <UpdateModalBody>
            <h2>Удаление</h2>
            <p>Вы точно хотите удалить конспект?</p>
            <UpdateModalFooter>
              <UpdateModalBtnWhite onClick={() => setRemoveModal(false)}>Отмена</UpdateModalBtnWhite>
              <UpdateModalBtn onClick={() => props.remove(props.item.id)}>Удалить</UpdateModalBtn>
            </UpdateModalFooter>
          </UpdateModalBody>
        </UpdateModal>
      }
    </>
  );
};

function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    [ref, handler]
  );
}

export default EditorOpenDoc;